// extracted by mini-css-extract-plugin
export default {"root":"Mwabje","line":"CJxENL"};